import {
    GET_ADDRESS_DATA,
    GET_PERSONAL_DATA,
    GET_SHIPMENT_DATA,
    GET_ADDRESS_VALID,
    GET_PERSONAL_VALID,
    GET_PHONE_PREFIX_VALID,
    GET_ORDER,
    GET_ORDER_LOADING,
    GET_PAYLANDS_PARAMS,
    GET_PAYMENT_METHOD,
    GET_BITCOIN_PARAMS,
    GET_CARDS,
    GET_SELECTED_CARD_UUID,
    GET_REGIONS,
    GET_SHIPPING_TYPE,
    GET_COUPON,
    GET_IS_CANARIAS,
    GET_FIELDS
} from "./types";

import { isCanarias } from "../../utils";

const wizardGetters = {
    [GET_ADDRESS_DATA](state) {
        return state.addressData;
    },
    [GET_PERSONAL_DATA](state) {
        return state.personalData;
    },
    [GET_SHIPMENT_DATA](state) {
        return state.shippingData;
    },
    [GET_FIELDS](state, getters) {
        const fields = {
            ...getters[GET_PERSONAL_DATA]
        };

        if(!getters[GET_IS_CANARIAS]) delete fields.dni;

        return fields;
    },
    [GET_ADDRESS_VALID](state, getters) {
        let valid = true;
        valid = Object.entries(getters[GET_ADDRESS_DATA].personal).every(item => {
            if (item[1].value != "" || item[1].name == 'info' || item[1].name == 'observations') {
                return true;
            } else {
                return false;
            }
        });

        valid = getters[GET_ADDRESS_DATA].postal.value != "" && getters[GET_ADDRESS_DATA].postal.value != null && valid ? true : false;
        valid = getters[GET_ADDRESS_DATA].country.value != "" && getters[GET_ADDRESS_DATA].country.value != null && valid ? true : false;

        return valid;
    },
    [GET_PERSONAL_VALID](state, getters) {
        let valid = true;
    
        valid = Object.entries(getters[GET_FIELDS]).every(([key, field]) => {
            if (key === 'phone_prefix') return true;
            return field.value != "" && field.value != null;
        });
    
        return valid;
    },
    [GET_PHONE_PREFIX_VALID](state, getters) {
        const phonePrefix = getters[GET_FIELDS].phone_prefix;
        return phonePrefix.value != "" && phonePrefix.value != null;
    },
    
    
    GET_ORDER(state) {
        return state.order;
    },
    [GET_ORDER_LOADING](state){
        return state.orderLoading;
    },
    [GET_PAYLANDS_PARAMS](state){
        return state.paylandsParams;
    },
    [GET_PAYMENT_METHOD](state){
        return state.paymentMethod;
    },
    [GET_BITCOIN_PARAMS](state){
        return state.bitcoinParams
    },
    [GET_CARDS](state){
        return state.cards;
    },
    [GET_SELECTED_CARD_UUID](state){
        return state.selectedCardUUID
    },
    [GET_REGIONS](state){
        return state.regions
    },
    [GET_SHIPPING_TYPE](state){
        return state.shippingType
    },
    [GET_COUPON](state){
        return state.coupon;
    },
    [GET_IS_CANARIAS](state){
        return isCanarias(state.addressData.postal.value);
    },
};

export default wizardGetters;
